import { Link } from 'components/table/types';

export function createLinks(pages: number, activePage: number = 1): Link[] {
  const links: Array<Link> = [];

  for (let pageIndex = 1; pageIndex <= pages; pageIndex++) {
    links.push({
      url: `/?page=${pageIndex}`,
      label: pageIndex.toString(),
      active: pageIndex == activePage,
      page: pageIndex
    });
  }
  return links;
}
